export default "__VITE_ASSET__DTwN6oQk__"